<div class="health-questions">
  <div *ngIf="!cemsSummary" class="text-center mt-5 mb-5">
    <h5 [innerHTML]="'HEALTH_QUESTIONNAIRE.Title' | labelText"></h5>
  </div>
  <div class="card" *ngIf="form">
    <form [formGroup]="form">
      <div class="card-body mt-4 ms-3" [class.pl-0]="cemsSummary">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
            <div class="question-block">
              <label class="mb-0">
                {{ 'HEALTH_QUESTIONNAIRE.Question1' | labelText }}
                <app-tooltip
                  [title]="'HEALTH_QUESTIONNAIRE.ExampleReformDismissalTitle' | labelText"
                  [text]="'HEALTH_QUESTIONNAIRE.ExampleReformDismissalText' | labelText"
                  [tooltipPosition]="'top'"
                >
                </app-tooltip>
              </label>

              <div class="buttons-block">
                <app-combobox-form-control
                  (onChanged)="isLaidOffForIllnessChange($event)"
                  [parentForm]="form"
                  [formControlName]="'laidOffForIllness'"
                  [title]=""
                  class="no-title yes-invalid"
                  [wrongAnswer]="constants.yesAnswer"
                >
                </app-combobox-form-control>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" *ngIf="isLaidOffForIllness">
            <div class="error-block">
              <span class="text">
                {{ 'Common.YouCannotSubscribeOnline' | labelText }}
              </span>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
            <div class="question-block">
              <label class="mb-0">
                {{ 'HEALTH_QUESTIONNAIRE.Question2' | labelText }}
                <app-tooltip
                  [title]="'HEALTH_QUESTIONNAIRE.TemporaryDisabilityTitle' | labelText"
                  [text]="'HEALTH_QUESTIONNAIRE.TemporaryDisabilityText' | labelText"
                  [tooltipPosition]="'top'"
                >
                </app-tooltip>
              </label>
              <div class="buttons-block">
                <app-combobox-form-control
                  (onChanged)="tempUnableWorkChange($event)"
                  [parentForm]="form"
                  [formControlName]="'tempUnableWork'"
                  [title]=""
                  [wrongAnswer]="constants.yesAnswer"
                  class="no-title yes-invalid"
                >
                </app-combobox-form-control>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" *ngIf="isTempUnableWork">
            <div class="error-block">
              <span class="text">
                {{ 'Common.YouCannotSubscribeOnline' | labelText }}
              </span>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
            <div class="question-block">
              <label class="mb-0">
                {{ 'HEALTH_QUESTIONNAIRE.Question3' | labelText }}
              </label>
              <div class="buttons-block">
                <app-combobox-form-control
                  (onChanged)="offWorkMore30daysChange($event)"
                  [parentForm]="form"
                  [formControlName]="'offWorkMore30days'"
                  [title]=""
                  [wrongAnswer]="constants.yesAnswer"
                  class="no-title yes-invalid"
                >
                </app-combobox-form-control>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" *ngIf="isOffWorkMore30days">
            <div class="error-block">
              <span class="text">
                {{ 'Common.YouCannotSubscribeOnline' | labelText }}
              </span>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
            <div class="question-block">
              <label class="mb-0">
                {{ 'HEALTH_QUESTIONNAIRE.Question4' | labelText }}
              </label>
              <div class="buttons-block">
                <app-combobox-form-control
                  (onChanged)="treatmentMore30daysChange($event)"
                  [parentForm]="form"
                  [formControlName]="'treatmentMore30days'"
                  [title]=""
                  [wrongAnswer]="constants.yesAnswer"
                  class="no-title yes-invalid"
                >
                </app-combobox-form-control>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" *ngIf="isTreatmentMore30days">
            <div class="error-block">
              <span class="text">
                {{ 'Common.YouCannotSubscribeOnline' | labelText }}
              </span>
            </div>
          </div>
        </div>

        <div class="row mt-4" *ngIf="!cemsSummary">
          <div class="col-md-12 center">
            <button
              type="button"
              class="btn btn-primary validation-button"
              (click)="submit()"
              [disabled]="isFormInvalid"
            >
              {{ 'Common.Validate' | labelText }}
            </button>
          </div>
        </div>
      </div>
      <div class="warning" *ngIf="!cemsSummary">
        <span class="fw-600">{{ 'HEALTH_QUESTIONNAIRE.HelpTitle' | labelText }}</span>
        <br />
        {{ 'HEALTH_QUESTIONNAIRE.HelpContent' | labelText }}
      </div>
    </form>
  </div>
</div>
